export default __webpack_public_path__ + "static/media/icone-upload-foto.3ba0d57d.svg";